import { Analysis } from '../masterdata/models/analysis';
import { Component, OnInit, Input } from '@angular/core';
import { LabMDM } from '../masterdata/models/lab';
import { ErrorHandler } from '../utils/error-handler';
import { MessagesService } from '../messages/messages.service';
import { MasterDataService } from '../masterdata/masterdata.service';
import { FlowCell } from '../masterdata/models/flowcell';
import { OperetionHistoryDTO } from '../masterdata/models/operationHistory';
import { SelectableLab } from '../carrier/selectable-lab';

@Component({
  selector: 'app-mdm-analysis',
  templateUrl: './mdm-analysis.component.html',
  styleUrls: ['./mdm-analysis.component.css']
})
export class MdmAnalysisComponent implements OnInit {

  @Input() masterLists: Analysis[];
  @Input() tableCols: any[];
  @Input() title: string;
  @Input() labOptions: LabMDM[];
  @Input() checkSelectedLab: SelectableLab;
  @Input() loading:boolean;
    
  puid = localStorage.getItem('PUID');
  labOption: LabMDM[] = [];
  selectedMasterList: Analysis;
  popupTitle: string;
  displayMasterListDialog: boolean = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  isNewMasterList: boolean;
  masterList: Analysis;
  selectedLabName: string;
  selectedLab: LabMDM;
  displayName: any;
  blocked: boolean = false;
  sequencerOptions: any[];
  sequencerOption: any[]=[];
  flowCellTypeOptions: any[];
  flowCellModeOptions: any[];
  capabilityModeOptions: any[];
  physicalLaneLimit: number = 5;
  capabilityList: any[];
  flowCellCapabilities: string[];
  selectedSequencer: any;
  selectedFlowCellType: any;
  selectedFlowCellMode: any;
  selectedCapabilityMode: any;
  capabilityLength: number;

  capabilityDuration: number;
  dialogBoxCell: boolean = false;
  readModeCountList = [];
  flowCellReadMode =[];
  capabilityListMode = [];
  oldCellMode: string;
  newCellMode : string;


  constructor(private _messageService: MessagesService, private _masterDataService: MasterDataService) { }


  ngOnInit() {

    this.getActiveOptionsForDropdowns();
    
  }

  //Display Add Dialog upon clicking Add button
  showDialogToAddMasterList() {
    this.isNewMasterList = true;
    this.masterList = new Analysis;
    this.displayMasterListDialog = true;
    this.capabilityList = [];
    this.readModeCountList = [];
    this.capabilityListMode = [];
    this.getActiveOptionsForDropdowns();

  }

  onRowSelect(event) {
    this.isNewMasterList = false;
    this.masterList = this.cloneMasterList(event.data);
    this.displayMasterListDialog = true;

    if(!this.masterList.product) {
      this.masterList.productId = '';
    }
    this.getActiveOptionsForDropdowns();
    
  }
    
  getActiveOptionsForDropdowns(): any {
    this.labOption=[];
    this._masterDataService.getLabs(true).subscribe(
      resultLabs => {
        if (!resultLabs) {
          return;
        }  
        let checkSelectedLabName = this.checkSelectedLab.lab.name;
        this.labOptions = resultLabs.data;
        this.labOptions.forEach(lab => {
          
          if(lab.name == checkSelectedLabName) {
            this.labOption.push(lab);
          }
          if (this.masterList && this.masterList.lab && lab._id == this.masterList.lab._id) {
            this.selectedLabName = this.masterList.lab.name;
            this.selectedLab = lab;
          }
        })
        this.labOptions= this.labOption;
        if (!this.masterList || !this.masterList.lab || this.selectedLabName != this.masterList.lab.name)
          this.selectedLab = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );

    this.sequencerOption = [];
    this._masterDataService.getConfigList(this.checkSelectedLab.lab._id, "machineType", 0, 100).subscribe(
      resultMachineTypes => {
        if (!resultMachineTypes) {
          return;
        }  
        this.sequencerOptions = resultMachineTypes.data;
        this.sequencerOptions.forEach(machineType => {
          
          if(machineType.sequencer && machineType.active) {
            this.sequencerOption.push({label: machineType.name, name: machineType.name});
          }

          if(this.masterList && this.masterList.sequencer && machineType.name == this.masterList.sequencer){
            var selectedSeq = {label: machineType.name, name: machineType.name};
            this.selectedSequencer = selectedSeq;
          }
        })

        this.sequencerOptions= this.sequencerOption;
        if (!this.masterList || !this.masterList.sequencer || this.selectedSequencer.name != this.masterList.sequencer)
          this.selectedSequencer = null;
      },
      error => {
        let message = this.errorHandler.handleError(error);
        this._messageService.addErrorMessage(message);
        }
    );

  }

  isSaveDisabled() {
     return !(this.masterList && this.masterList.analysisName  && this.masterList.pipelineName 
       && this.masterList.versionOfAnalysis && this.selectedSequencer && this.selectedLab        
       && this.masterList && ((this.masterList.product && this.masterList.productId)
       || (!this.masterList.product && !this.masterList.productId) ));
  }

  isProductIdDisabled() {
      return !(this.masterList && this.masterList.product);    
  }
  saveMasterListData() { 
    //in case the list not exists for the first time
    var labObj = new LabMDM();
    labObj._id = this.selectedLab._id;
    labObj.name = this.selectedLab.name;
    labObj.businessArea = this.selectedLab.businessArea;
    this.masterList.lab = labObj;
    this.masterList.sequencer = this.selectedSequencer.name;
    if(this.masterList.active==undefined) {
      this.masterList.active =false;
    }
    if (!this.masterList.product) {
      this.masterList.productId = "none";
    }
    this.appendHistory("Analysis");
    var inputData = JSON.stringify(this.masterList);
    
    if (this.isNewMasterList) {
      this.saveMasterData(inputData);
    }
    else {
      this.updateMasterData(inputData);
    }
      // this._masterDataService.validateAnalysis(this.selectedLab._id,this.masterList.sequencer,
      //   this.masterList.productId,this.masterList.active,this.masterList._id).subscribe(
      //     analysis=> {
      //       if (this.masterList.active && analysis.data && (analysis.data._id!=this.masterList._id)) {
      //         if(!this.masterList.product) {
      //           this.masterList.productId = '';
      //         }
      //         this._messageService.addErrorMessage({ severity: 'error', summary: 'Duplicate Entry!', detail: 'Entry exist with same analysis pipeline' });
      //         this.blocked=false;
      
      //       } else {
      //         if (this.isNewMasterList) {
      //           this.saveMasterData(inputData);
      //         }
      //         else {
      //           this.updateMasterData(inputData);
      //         }
          
      //       }
      //     },
      //     error => {
      //       this.handleError(error);
      //       }
      //   );
  }
  private handleError(error: any) {
    this.blocked=false;
    let errorMessage = this.errorHandler.handleError(error);
    this._messageService.addErrorMessage(errorMessage);
  }

  //Inserts a new Template in DB
  saveMasterData(jsonString: string) {
    if(!this.masterLists){
      this.masterLists = [];
    }

    this.blocked=true;
    this._masterDataService.saveConfig(this.selectedLab, jsonString, "analysis").subscribe(
      flowCellJson=> {
        if (!flowCellJson) {
          return;
        }
        this.displayMasterListDialog = false;
        this.masterList = flowCellJson.data;
        
        this.masterLists.push(this.masterList);
        this.masterList = null;
        this._messageService.addSuccessMessage({ severity: 'success', summary: 'Saved Analysis!', detail: 'Analysis is created.' });
        this.blocked=false;
      },
      error => {
        this.handleError(error);
        }
    );
  }
  //Updates a Template in DB
  updateMasterData(jsonString: string) {

    this.blocked=true;
      this._masterDataService.updateConfig(this.selectedLab, jsonString, "analysis").subscribe(
        flowCellJson => {
          if (!flowCellJson) {
            return;
          }
          this.masterList = flowCellJson.data;
          this.masterLists[this.masterLists.indexOf(this.selectedMasterList)] = this.masterList;
          this.masterList = null;
          this._messageService.addSuccessMessage({ severity: 'success', summary: 'Updated Analysis!', detail: 'Analysis is Updated.' });
          this.displayMasterListDialog = false;
          this.blocked=false;
        },
        error => {
          this.handleError(error);
          }  
      );
    
    
  }


  disableDialog() {
    this.dialogBoxCell = false;
    this.selectedCapabilityMode = null;
    this.capabilityLength = null;
    this.capabilityDuration = null;
  }

  cloneMasterList(list: any): any {
    let masterList = {};
    for (let prop in list) {
      masterList[prop] = list[prop];
    }
    return masterList;
  }



  appendHistory(tabName: string){
    let historyObj:OperetionHistoryDTO = new OperetionHistoryDTO();
    historyObj.puid = this.puid;
    historyObj.operationDateTime = new Date();
    historyObj.tabName = tabName;
    if(this.masterList.history){
      this.masterList.history.push(historyObj);
    } else {
      this.masterList.history = [];
      this.masterList.history.push(historyObj);
    }
  }

  checkValue(event:any){
    
    if(!this.masterList.product) {
        this.masterList.productId = '';
    }
  }
}
